import useIsMobile from '../hooks/useIsMobile';

const bg = '#f0ebe3';
const red = '#6B1A1A';
const body = 'Cormorant Garamond, serif';

function Footer() {
  const isMobile = useIsMobile();

  return (
    <footer style={{ backgroundColor: bg, borderTop: '0.5px solid #d4c9bc', padding: isMobile ? '40px 24px' : '40px 60px', fontFamily: body }}>
      <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'space-between', alignItems: isMobile ? 'flex-start' : 'center', gap: isMobile ? '30px' : '0' }}>
        <div>
          <p style={{ color: red, fontSize: '13px', letterSpacing: '4px', margin: '0 0 6px' }}>HERMES PARTNER CAPITAL</p>
          <p style={{ color: '#888', fontSize: '12px', margin: 0, fontStyle: 'italic' }}>— Fortune Favors the Bold —</p>
        </div>
        <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '16px' : '32px' }}>
          <a href="/services" style={{ color: '#555', fontSize: '12px', letterSpacing: '2px', textDecoration: 'none' }}>Services</a>
          <a href="/contact" style={{ color: '#555', fontSize: '12px', letterSpacing: '2px', textDecoration: 'none' }}>Contact</a>
        </div>
        <div style={{ textAlign: isMobile ? 'left' : 'right' }}>
          <p style={{ color: '#888', fontSize: '11px', margin: '0 0 4px' }}>Chicagoland, Illinois</p>
          <p style={{ color: '#888', fontSize: '11px', margin: '0 0 4px' }}>info@hermespartnercapital.com</p>
          <p style={{ color: '#888', fontSize: '11px', margin: 0 }}>(224) 475-9646</p>
        </div>
      </div>
      <div style={{ borderTop: '0.5px solid #d4c9bc', marginTop: '30px', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ color: '#aaa', fontSize: '11px', margin: 0, letterSpacing: '2px' }}>© 2025 HERMES PARTNER CAPITAL · ALL RIGHTS RESERVED</p>
      </div>
    </footer>
  );
}

export default Footer;